function ensureAttribute(element: HTMLElement, name: string) {
    if (!element.hasAttribute(name)) {
        element.setAttribute(name, '');
    }
}

export function setFocusableElement(element: HTMLElement | null, orderNumber: string) {
    if (!element) return;

    ensureAttribute(element, 'focusable');
    element.setAttribute('order', orderNumber);
}

export function setFocusableGroup(root: HTMLElement | null) {
    if (!root) return;

    ensureAttribute(root, 'group');
    ensureAttribute(root, 'modal');
}
